import { FC, PropsWithChildren } from "react";
import { FieldErrors, FieldValues } from "react-hook-form";
import { FormErrorMessage } from "./ErrorMessage";

type FormInputLayoutProps = {
  name: string;
  label?: string;
  error?: FieldErrors<FieldValues> | string;
  showError?: boolean;
  classNameForm?: string;
  id?: string;
} & PropsWithChildren;

/**
 * @component
 * Компонент обвертка для создания формы полей
 * @description
 * Обвертка для формы, с label и отображением ошибки
 */

export const FormInputLayout: FC<FormInputLayoutProps> = ({
  name,
  id,
  label,
  error,
  showError = true,
  classNameForm,
  children,
}) => {
  const hasError = showError && error;

  const textStyle = !hasError ? 'text-[#474A51]' : 'text-[#b21913]';

  return (
    <div className={`flex flex-col gap-1 ${classNameForm}`}>
      {label && (
        <label
          htmlFor={id ? id : name}
          className={`${textStyle} font-semibold mb-[5px]`}
        >
          {label}
        </label>
      )}
      {children}
      {/* {hasError && <FormErrorMessage name={name} error={error} />} */}
    </div>
  );
};